import React from "react"
import PropTypes from "prop-types"

import {
    // sorting functions
    enumLabelSort,
} from "shared/search/containers/Filter/Filters"
import { enumGenericFilter } from "shared/search/containers/Filter/FilterCreators"

export const GeographyPartyFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
GeographyPartyFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    sortBy: PropTypes.func,
}
GeographyPartyFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "geographyPartyFilter",
    filterKey: "senate_control__in",
    enumItems: DjangIO.app.person.types.Party.region_supported_items().filter(
        (item) => item.value !== DjangIO.app.person.types.Party.NoParty.value,
    ),
    sortBy: enumLabelSort,
}
